import React from 'react';
import { ModalTabs } from '~/App/Modules/Testimonials/Pages/Publish/Editor/Containers/PublishModal/types';
import cx from 'classnames';

const tabItems = [
  {
    label: ModalTabs.All,
    iconClassName: 'icon-library',
  },
  { label: ModalTabs.Responses, iconClassName: 'icon-responses' },
  { label: ModalTabs.Social, iconClassName: 'icon-socials' },
  { label: ModalTabs.Uploads, iconClassName: 'icon-cloud-upload' },
];

export interface TabsProps {
  selectedTab: string;
  onSelectedTab: (label: ModalTabs) => void;
}

export interface TabItemProps {
  label: ModalTabs;
  iconClassName: string;
  onSelected: (label: ModalTabs) => void;
  selected?: boolean;
}

function TabItem({ label, selected, onSelected, iconClassName }: TabItemProps) {
  const selectedColorBackground = 'bg-yellow-50';

  return (
    <div
      onClick={() => onSelected(label)}
      className={cx(
        'h-[40px] px-[20px] py-[4px] cursor-pointer flex items-center hover:v2-bg-yellow-50',
        { [selectedColorBackground]: selected }
      )}
    >
      <i className={`icon ${iconClassName}`} />
      <span className='ml-[10px]'>{label}</span>
    </div>
  );
}

export default function Tabs({ selectedTab, onSelectedTab }: TabsProps) {
  const handleOnSelectedTab = (label: ModalTabs) => {
    onSelectedTab(label);
  };

  return (
    <div className='flex flex-row text-[16px]'>
      {tabItems.map((item, key) => {
        return (
          <TabItem
            {...item}
            key={key}
            onSelected={handleOnSelectedTab}
            selected={item.label === selectedTab ?? true}
          />
        );
      })}
    </div>
  );
}
